import { CustomCellRendererProps } from 'ag-grid-react';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { TechLibraryDocumentType } from '@cas/config/documents';
import { DefaultCell } from '@dmc/ui/tables';

// Todo: Replace this cell renderer with a valueFormatter (for display) and getQuickFilterText callback (for searching by translation value).
export const DocumentTypeCellRenderer = ({
  value,
  ...otherProps
}: CustomCellRendererProps<
  { documentType: TechLibraryDocumentType },
  TechLibraryDocumentType
>): ReactElement => {
  const { t } = useTranslation();

  const text = typeof value === 'string' ? t(`DocType.${value}`) : '';

  return <DefaultCell {...otherProps} value={text} />;
};

export default DocumentTypeCellRenderer;
